import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { currencyFormat } from '@/libs/utils';
import { Card } from './card';
import { Product } from '@/core/domain/entities/Product';

export const ProductCard = (props: Product) => {
  const router = useRouter();

  const handleRoute = () => {
    router.push(`/products/${props.id}`);
  };

  const currency = (props.pricing?.currency || props.currency || 'GHS').toUpperCase();
  const displayCurrency = /^[A-Z]{3}$/.test(currency) ? currency : 'GHS';

  const asLowAsDaily =
    props.pss_options?.as_low_as_daily ??
    (props.pss_options?.as_low_as_weekly != null
      ? Math.ceil(props.pss_options.as_low_as_weekly / 7)
      : undefined) ??
    (props.pss_options?.as_low_as_monthly != null
      ? Math.ceil(props.pss_options.as_low_as_monthly / 30)
      : 0);

  return (
    <Card
      className="sm:min-w[220px] group flex h-fit  min-w-[170px]  cursor-pointer snap-start flex-col border-none shadow-none md:min-w-[260px] 2xl:min-w-[280px]"
      onClick={handleRoute}
    >
      <div className="relative flex h-[200px] w-full  items-center justify-center rounded-2xl bg-[#F4F4F4] md:h-[280px]">
        <Image
          src={props.image_url ?? '/assets/images/no-image.png'}
          width={150}
          height={150}
          quality={100}
          alt={props.name}
          className="grid-2 row-span-3  h-5/6 w-full object-contain object-center p-2 "
        />
        {props.shop_logo && (
          <Image
            src={props.shop_logo}
            width={48}
            height={48}
            quality={100}
            alt={props.shop_name}
            className="absolute bottom-2 left-2 size-8  rounded-full border border-black-50 bg-slate-400 object-cover object-center md:size-12"
          />
        )}
      </div>
      <div className="mt-2.5 flex size-full flex-col justify-between px-2 pb-2">
        <h1 className="line-clamp-2 text-sm transition-all group-hover:text-motito-purple group-hover:underline max-lg:truncate md:text-base">
          {props.name}
        </h1>
        {props.shop_name ? (
          <p className="line-clamp-1 text-xs text-black-100">
            Sold by {props.shop_name}
          </p>
        ) : null}

        <h3 className=" mt-1.5 line-clamp-1 font-garnettSemiBold  text-xl text-black-500 md:text-2xl">
          {displayCurrency}{' '}
          {currencyFormat(
            +(
              props.pricing.current_display_price ??
              +props.pricing.display_price
            )
          )}
        </h3>
        {asLowAsDaily > 0 ? (
          <span className="text-sm font-light text-accent">
            Pay as low as GHS {currencyFormat(asLowAsDaily)}/day
          </span>
        ) : null}
      </div>
    </Card>
  );
};
